export const APP_LOCALES = {
	'es': 'Español',
	'en': 'English (US)',
};

export default APP_LOCALES;
